import React from 'react';
import * as S from './styles';

interface NavbarLeftProps {
	children: React.ReactNode;
}

const NavbarLeft = ({ children }: NavbarLeftProps) => {
	return <S.Base>{children}</S.Base>;
};

export default NavbarLeft;
